import { Component } from '@angular/core';
import { NavigatorService } from 'src/app/services/navigator.service';
import { StateService } from 'src/app/services/state.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'module-select',
  templateUrl: './module-select.component.html',
  styleUrl: './module-select.component.css'
})
export class ModuleSelectComponent {

  constructor(
    private stateService: StateService,
    private navigator: NavigatorService,
    private userDataService: UserDataService
  ){}

  switchModule(module:string){
    if(module === 'airConditioners'){
      console.log('ustawiam klimatyzacje');
      this.stateService.setStateAirconditioners();
    } else if (module === 'pumps'){
      console.log('ustawiam pompy');
      this.stateService.setStatePumps();
    }
    this.userDataService.establishIfUserPlacedOrder();
    this.userDataService.setPrizeAmount();
    this.navigator.redirectToLandingPage();
  }
}
